var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block bg-warning-light rounded px-3 py-2 font-weight-bold"},[_vm._v("\n  "+_vm._s(_vm.value.replace(/(.{4})/g, "$1 ").trim())+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }